import Query from '../../components/Report';

const query = (page) =>
    page
        ? new Query('discover-domains-top-categories-page', { page })
        : new Query('discover-categories-view-confidence');

export default query;
